import { render, staticRenderFns } from "./OpenCard.vue?vue&type=template&id=0707323f&"
import script from "./OpenCard.vue?vue&type=script&lang=js&"
export * from "./OpenCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports